"use client";

import {
  StickyNavigation,
  useSecondaryNavHeight,
} from "@/components/StickyNavigation";
import { BuilderBlockProps } from "@/types";
import { BuilderBlock } from "@builder.io/sdk-react";
import { FC, ReactNode, useLayoutEffect } from "react";

type StickyNavigationBlockProps = {
  links: {
    title: string;
    href: string;
    dlt: string;
    dld: string;
  }[];
  children: ReactNode;
  builderBlock: BuilderBlock;
} & BuilderBlockProps;

export const StickyNavigationBlock: FC<StickyNavigationBlockProps> = ({
  links = [],
  attributes,
  children,
  builderBlock,
}) => {
  const offsetTop =
    parseInt(builderBlock.responsiveStyles?.large?.top || "") || 0;
  const secondaryNavHeight = useSecondaryNavHeight();
  const baseOffsetTop = offsetTop + secondaryNavHeight;
  // Adjustment for pixel differences in sticky positioning calculations,
  // applied only when there is a positive base offset
  const adjustOffset = baseOffsetTop > 0 ? -1 : 0;
  const totalOffsetTop = baseOffsetTop + adjustOffset;

  // Update Builder wrapper's top style dynamically based on secondary nav height
  useLayoutEffect(() => {
    const isPageWithDockedNav = !!document.getElementById("dockedNav");
    const isPageWithSecondary = !!document.getElementById("secondaryNav");

    const wrapperElement: HTMLElement | null = document.querySelector(
      `[builder-id="${builderBlock.id}"]`,
    );
    if (wrapperElement) {
      wrapperElement.style.top = `${totalOffsetTop}px`;
      if (isPageWithDockedNav && !isPageWithSecondary) {
        wrapperElement.style.position = "relative";
      }
    }
  }, [totalOffsetTop, builderBlock.id]);

  return (
    <StickyNavigation links={links} offsetTop={totalOffsetTop} {...attributes}>
      {children}
    </StickyNavigation>
  );
};
